<template>
    <card-layout :items="categories" :max-per-row="maxPerRow" v-slot="{item: category, layout}">
        <resource-booking-category-card
            :category="category"
            :title-right="layout == 'wide'"
            :to="link + '/' + category.id"
        />
    </card-layout>
</template>

<script>
import ResourceBookingCategoryCard from './ResourceBookingCategoryCard.vue'
import CardLayout from './CardLayout.vue'
export default {
    name: 'zoezi-resource-booking-category-list',

    zoezi: {
        title: 'Service category list',
        icon: 'mdi-format-list-text'
    },

    props: {
        onlyShowCategories: {
            title: 'Categories',
            type: Array,
            fulltype: 'select',
            typeinfo: {
                multiple: true,
                text: 'name',
                value: 'id',
                getItems: () => window.$booking.getResourceBookingCategories(),
                placeholder: 'List all categories'
            },
            default: () => []
        },
        globalSiteSetting: {
            title: 'Filter by globally selected site',
            type: Boolean,
            default: true
        },
        sites: {
            title: 'Filter by site',
            type: Array,
            fulltype: 'select',
            typeinfo: {
                getItems() {
                    return window.$zoeziapi.get('/api/public/settings/get').then(settings => {
                        return settings.sites.sort((a,b) => a.name.localeCompare(b.name));
                    });
                },
                text: 'name',
                value: 'id',
                multiple: true,
                placeholder: 'Show all sites',
                visible: '!globalSiteSetting'
            },
            default: () => []
        },
        sort: {
            title: 'Sort by default on',
            type: String,
            fulltype: 'select',
            typeinfo: {
                getItems() {
                    return [
                        {id: 'admin', name: "Administration's sorting"},
                        {id: 'name', name: 'Category name'},
                        {id: 'created', name: 'Newly added'},
                    ].map(x => ({...x, name: window.$translate(x.name)}));
                },
                text: 'name',
                value: 'id',
                multiple: false
            },
            default: () => 'admin'
        },
        showSortFilter: {
            title: 'Show sorting filter for client',
            type: Boolean,
            default: true
        },
        link: {
            title: 'Page showing service category',
            type: String,
            fulltype: 'page'
        },
        maxPerRow: {
            title: 'Max number of cards per row',
            type: Number,
            fulltype: 'number-slider',
            typeinfo: {
                min: 1,
                max: 4,
                step: 1
            },
            default: 4
        }
    },

    components: {
        ResourceBookingCategoryCard,
        CardLayout
    },

    data: () => ({
        unsubscribe: null
    }),

    computed: {
        sortFn() {
            if (this.sort == 'name') {
                return (a,b) => a.name.localeCompare(b.name);
            } else if (this.sort == 'created') {
                return (a,b) => Date.newFull(b.created) - Date.newFull(a.created)
            }

            return null;
        },
        filterOnSites() {
            if (this.globalSiteSetting && this.$store.state.selectedSiteId) {
                return [this.$store.state.selectedSiteId];
            }

            if (!this.sites || this.sites.length == 0) {
                return null;
            }

            return this.sites.filter(site => site !== null && site !== undefined);
        },
        categories() {
            let categories = this.$store.state.settings?.resourcebookingcategories;
            if (!categories) {
                return [];
            }

            let result = categories.filter(c => {
                // Check site filter
                if (this.filterOnSites) {
                    if (!c.sites.some(site => this.filterOnSites.includes(site))) {
                        return false;
                    }
                }
                
                // Check category filter
                if (this.onlyShowCategories?.length > 0) {
                    if (!this.onlyShowCategories.includes(c.id)) {
                        return false;
                    }
                }

                return true;
            });

            if (this.sortFn) {
                result.sort(this.sortFn);
            }

            return result;
        }
    },

    watch: {
    },

    mounted() {
        this.unsubscribe = this.$root.$api.subscribe({type: 'resourcebookingcategory', callback: () => this.$api.reloadSettings()})
    },
    destroyed() {
        this.unsubscribe?.();
    }
}
</script>
